// document.addEventListener('DOMContentLoaded', function () {
//     const targetNode = document.querySelector('body');

//     if (!targetNode) return;

//     const config = { childList: true, subtree: true };

//     const callback = function (mutationsList) {
//         for (const mutation of mutationsList) {
//             if (mutation.type === 'childList') {
//                 // Detect Cart Drawer Open
//                 const cartDrawer = document.querySelector('cart-drawer, .drawer');

//                 console.log('cartDrawer', cartDrawer);

//                 if (cartDrawer && cartDrawer.classList.contains('active')) {
//                     console.log('Cart Drawer Opened!');
//                     // Your code here
//                 }

//                 // Detect Cart Drawer Items Change
//                 const cartItems = document.querySelectorAll('.cart-items, cart-drawer-items');
//                 if (cartItems.length > 0) {
//                     console.log('Cart Items Changed!');

//                     let noteText = '';

//                     const maincartitems = document.querySelector('#main-cart-items');

//                     const CartDrawer = document.querySelector('#CartDrawer');

//                     if (maincartitems) {
//                         document.querySelectorAll('#main-cart-items .cart-item').forEach(item => {
//                             const productName = item.querySelector('.cart-item__name')?.textContent.trim() || '';
//                             const quantityNote = item.querySelector('.quantity__input')?.value;

//                             // Start building text for this product
//                             let productText = `Product: ${productName}\n`;
//                             let quantityText = `Quantity: ${quantityNote}\n`;
                            

//                             // Loop through all options inside <dl>
//                             item.querySelectorAll('dl .product-option').forEach(option => {
//                                 const label = option.querySelector('dt')?.textContent.trim() || '';
//                                 const value = option.querySelector('dd')?.textContent.trim() || '';
//                                 if (label && value) {
//                                     productText += `${label} ${value}\n`;
//                                 }
//                             });

//                             noteText += productText + quantityText + '\n' + '-----------' + '\n' + '\n';
//                         });

//                         const noteElementCartPage = document.querySelector('#Cart-note');

//                         if (noteElementCartPage) {
//                             setTimeout(() => {
//                                 noteElementCartPage.value = noteText.trim();
//                             }, 1000);
//                         }

//                         console.log("maincartitems", noteText);
//                     }
                    
//                     if (CartDrawer) {
//                         document.querySelectorAll('#CartDrawer .cart-item').forEach(item => {
//                             const productName = item.querySelector('.cart-item__name')?.textContent.trim() || '';
//                             const quantityNote = item.querySelector('.quantity__input')?.value;

//                             // Start building text for this product
//                             let productText = `Product: ${productName}\n`;
//                             let quantityText = `Quantity: ${quantityNote}\n`;
                            

//                             // Loop through all options inside <dl>
//                             item.querySelectorAll('dl .product-option').forEach(option => {
//                                 const label = option.querySelector('dt')?.textContent.trim() || '';
//                                 const value = option.querySelector('dd')?.textContent.trim() || '';
//                                 if (label && value) {
//                                     productText += `${label} ${value}\n`;
//                                 }
//                             });

//                             noteText += productText + quantityText + '\n' + '-----------' + '\n' + '\n';
//                         });

//                         const noteElement = document.querySelector('#CartDrawer-Note');
                    
//                         if (noteElement) {
//                             setTimeout(() => {
//                                 noteElement.value = noteText.trim();
//                             }, 3000);
                            
//                         }

//                         console.log("CartDrawer", noteText);
//                     }

                    

                    


//                 }
//             }
//         }
//     };

//     const observer = new MutationObserver(callback);
//     observer.observe(targetNode, config);
// });
















document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.querySelector('cart-drawer.drawer');

    if (!cartDrawer) return;

    // Watch drawer open/close
    const drawerObserver = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.attributeName === 'class' && cartDrawer.classList.contains('active')) {
                console.log('Cart Drawer Opened!');
                updateCartNotes();
            }
        }
    });
    drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

    // Watch quantity changes
    document.body.addEventListener('change', e => {
        if (e.target.matches('.quantity__input')) {
            console.log('Quantity changed!');
            updateCartNotes();
        }
    });

    // 🔥 Watch for any cart item DOM changes (add/remove/update)
    const cartItemsContainer = document.querySelector('#CartDrawer .cart-items, #CartDrawer cart-drawer-items');
    if (cartItemsContainer) {
        const itemsObserver = new MutationObserver(() => {
            console.log('Cart Drawer Items Changed!');
            updateCartNotes();
        });
        itemsObserver.observe(cartItemsContainer, { childList: true, subtree: true });
    }

    // Function to update notes everywhere + API
    function updateCartNotes() {
        let noteText = '';

        // Cart Page
        const maincartitems = document.querySelector('#main-cart-items');
        if (maincartitems) {
            maincartitems.querySelectorAll('.cart-item').forEach(item => {
                noteText += buildItemText(item);
            });
            const noteElementCartPage = document.querySelector('#Cart-note');
            if (noteElementCartPage) noteElementCartPage.value = noteText.trim();
        }

        // Cart Drawer
        const CartDrawer = document.querySelector('#CartDrawer');
        if (CartDrawer) {
            CartDrawer.querySelectorAll('.cart-item').forEach(item => {
                noteText += buildItemText(item);
            });
            const noteElement = document.querySelector('#CartDrawer-Note');
            if (noteElement) noteElement.value = noteText.trim();
        }

        // Update Shopify Cart API
        if (noteText.trim() !== '') {
            setTimeout(() => {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ note: noteText.trim() })
                })
                .then(res => res.json())
                .then(data => {
                    console.log("Cart note updated:", data.note);
                })
                .catch(err => console.error("Cart update error:", err));
            }, 1000);
        }
    }

    // Helper: build product info text
    function buildItemText(item) {
        const productName = item.querySelector('.cart-item__name')?.textContent.trim() || '';
        const quantityNote = item.querySelector('.quantity__input')?.value || '0';

        let text = `Product: ${productName}\n`;
        text += `Quantity: ${quantityNote}\n`;

        item.querySelectorAll('dl .product-option').forEach(option => {
            const label = option.querySelector('dt')?.textContent.trim() || '';
            const value = option.querySelector('dd')?.textContent.trim() || '';
            if (label && value) {
                text += `${label} ${value}\n`;
            }
        });

        return text + '\n-----------\n\n';
    }
});
